import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recruters-course',
  templateUrl: './recruters-course.component.html',
  styleUrls: ['./recruters-course.component.scss']
})
export class RecrutersCourseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
